<template>
  <div v-motion-slide-top class="app-lockscreen">
    <div class="lock-login">
      <div class="lock-title">
        <img :src="`/logos/${ROSA_PLATFORM || 'logo'}_rgb.png`" alt="logo" />
        {{ ROSA_TITLE }}
      </div>
      <div class="lock-subtitle">基于安全考虑，长时间未操作已锁屏</div>
      <el-form ref="form" :model="model" class="px-72px py-48px" @submit.native.prevent>
        <!-- <el-form-item prop="password" class="mb-32px" :rules="rules">
          <el-input
            v-model="model.password"
            class="lock-login__password"
            type="password"
            auto-complete="on"
            placeholder="请输入密码"
            clearable
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button :loading="loading" size="medium" class="lock-login__btn" @click.prevent="handleLogin">
            解锁进入
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Form } from 'element-ui';
const { ROSA_TITLE, ROSA_PLATFORM, lockReset } = useAppStore();
const form = ref<Form | null>(null);
const model = ref({ password: '' });
const loading = ref(false);
const userStore = useUserStore();
const appStore = useAppStore();
const { showLockScreen } = storeToRefs(appStore);
const rules = [{ required: true, message: '请输入密码' }];
const handleLogin = async () => {
  try {
    // loading.value = true;
    // const valid = await form.value?.validate();
    // if (!valid || !showLockScreen.value) return;
    // const { msg, code }: any = await userStore.unLockLogin({
    //   username: showLockScreen.value,
    //   password: btoa(model.value.password),
    // });
    // if (code !== 200) throw new Error(msg);
    lockReset();
    userStore.getInfo();
  } catch (error) {
    loading.value = false;
    console.error(error);
  }
};
onMounted(async () => {
  model.value.password = await getPassword();
});
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Alibaba PuHuiTi';
  font-weight: 700;
  src:
    url('//at.alicdn.com/wf/webfont/YSBuMAfTdZ0h/SsWQhc6LstAd.woff2') format('woff2'),
    url('//at.alicdn.com/wf/webfont/YSBuMAfTdZ0h/agDebxwpscxf.woff') format('woff');
  font-display: swap;
}

.app-lockscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: url('/assets/lockscreen-bg.png');

  .lock-login {
    width: 549px;
    // height: 424px;
    height: 344px;
    border-radius: 16px;
    background: white;
    border: 1px solid #e6e8ee;
    box-shadow: 0 0 24px rgb(0 0 0 / 4%);

    &__btn {
      width: 100%;
      height: 48px;
      color: white;
      border-radius: 4px;
      background-image: linear-gradient(270deg, #65b4ff 0%, #0387ff 100%);
    }

    &__password :deep(.el-input__inner) {
      height: 48px;
      font-size: larger;
      letter-spacing: 1px;
    }
  }

  .lock-title {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 76px;
    color: #2c405a;
    font-family: 'Alibaba PuHuiTi', sans-serif;
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    height: 36px;
    text-align: center;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .lock-subtitle {
    color: var(--color-text-primary);
    font-size: medium;
    text-align: center;
    line-height: 24px;
  }
}
</style>
